// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceId } from './InvResource';
import { invManufacturerId } from './InvManufacturer';
import { invProductStatusEnum } from './InvProductStatusEnum';
import { invFoodGradeStatusEnum } from './InvFoodGradeStatusEnum';
import { invProductTypeEnum } from './InvProductTypeEnum';
import { fileStorageId } from './FileStorage';
import { foodClaimStatusEnum } from './FoodClaimStatusEnum';
import { z } from 'zod';
export const invProductId = (z.number());
export const invProduct = z.object({
    id: invProductId,
    resource_id: invResourceId.nullable(),
    manufacturer_id: invManufacturerId.nullable(),
    product_name: z.string().nullable(),
    manufacturer_product_code: z.string().nullable(),
    ean_code: z.string().nullable(),
    status: invProductStatusEnum,
    food_grade_status: invFoodGradeStatusEnum,
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    type: invProductTypeEnum.nullable(),
    photo_file_id: fileStorageId.nullable(),
    ingredients_text: z.string().nullable(),
    nutrition_basis: z.string().nullable(),
    non_gmo_status: foodClaimStatusEnum,
    vegan_status: foodClaimStatusEnum,
    vegetarian_status: foodClaimStatusEnum,
    shelf_life_days: z.number().nullable(),
    storage_requirements: z.string().nullable(),
    contains_no_nutrients: z.boolean(),
});
export const invProductInitializer = z.object({
    id: invProductId.optional(),
    resource_id: invResourceId.optional().nullable(),
    manufacturer_id: invManufacturerId.optional().nullable(),
    product_name: z.string().optional().nullable(),
    manufacturer_product_code: z.string().optional().nullable(),
    ean_code: z.string().optional().nullable(),
    status: invProductStatusEnum.optional(),
    food_grade_status: invFoodGradeStatusEnum.optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    type: invProductTypeEnum.optional().nullable(),
    photo_file_id: fileStorageId.optional().nullable(),
    ingredients_text: z.string().optional().nullable(),
    nutrition_basis: z.string().optional().nullable(),
    non_gmo_status: foodClaimStatusEnum.optional(),
    vegan_status: foodClaimStatusEnum.optional(),
    vegetarian_status: foodClaimStatusEnum.optional(),
    shelf_life_days: z.number().optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    contains_no_nutrients: z.boolean().optional(),
});
export const invProductMutator = z.object({
    id: invProductId.optional(),
    resource_id: invResourceId.optional().nullable(),
    manufacturer_id: invManufacturerId.optional().nullable(),
    product_name: z.string().optional().nullable(),
    manufacturer_product_code: z.string().optional().nullable(),
    ean_code: z.string().optional().nullable(),
    status: invProductStatusEnum.optional(),
    food_grade_status: invFoodGradeStatusEnum.optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    type: invProductTypeEnum.optional().nullable(),
    photo_file_id: fileStorageId.optional().nullable(),
    ingredients_text: z.string().optional().nullable(),
    nutrition_basis: z.string().optional().nullable(),
    non_gmo_status: foodClaimStatusEnum.optional(),
    vegan_status: foodClaimStatusEnum.optional(),
    vegetarian_status: foodClaimStatusEnum.optional(),
    shelf_life_days: z.number().optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    contains_no_nutrients: z.boolean().optional(),
});
//# sourceMappingURL=InvProduct.js.map